import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import { AppProvider } from './AppContext';

import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import WordImage from './pages/exercisePages/WordImage';
import CompletedExercisePage from "./pages/extraPages/CompletedExercisePage";
import BaseDerivativeWall from "./pages/exercisePages/BaseDerivativeWall";
import StimuliAssociation from './pages/exercisePages/StimuliAssociation';
import FindTheCorrectWordAudio from './pages/exercisePages/FindTheCorrectWordAudio';
import FindTheCorrectWordNoAudio from './pages/exercisePages/FindTheCorrectWordNoAudio';
import WordBuild from "./pages/exercisePages/WordBuild";
import WordSort from "./pages/exercisePages/WordSort";
import FastRead from './pages/exercisePages/FastRead';
import WriteAudioStimuli from "./pages/exercisePages/WriteAudioStimuli";
import WriteDerivativeWord from "./pages/exercisePages/WriteDerivativeWord";
import PatternMorph from "./pages/exercisePages/PatternMorph";
import VideoTutorial from "./pages/exercisePages/VideoTutorial";
import WordCracking from "./pages/exercisePages/WordCracking";
import MaintenancePage from './pages/MaintenancePage';
import ProtectedRoute from "./ProtectedRoute";

function App() {
    const isMaintenanceMode = false; // Set true to activate maintenance mode
    
    return (
        <AppProvider>
            <Router>
                <Routes>
                    {isMaintenanceMode ? (
                        <Route path="*" element={<MaintenancePage />} />
                    ) : (
                        <>
                            <Route path="/" element={<Navigate to="/login" replace />} />
                            
                            <Route path='/login' element={<LoginPage />} />
                            <Route path='/home' element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
                            <Route path='/word-image/:exerciseId' element={<ProtectedRoute><WordImage /></ProtectedRoute>} />
                            <Route path='/completed' element={<ProtectedRoute><CompletedExercisePage /></ProtectedRoute>} />
                            <Route path='/base-derivative-wall/:exerciseId' element={<ProtectedRoute><BaseDerivativeWall /></ProtectedRoute>} />
                            <Route path='/word-build/:exerciseId' element={<ProtectedRoute><WordBuild /></ProtectedRoute>} />
                            <Route path='/word-sort/:exerciseId' element={<ProtectedRoute><WordSort /></ProtectedRoute>} />
                            <Route path='/stimuli-association/:exerciseId' element={<ProtectedRoute><StimuliAssociation /></ProtectedRoute>} />
                            <Route path='/stimuli-audio/:exerciseId' element={<ProtectedRoute><WriteAudioStimuli /></ProtectedRoute>} />
                            <Route path='/find-the-correct-word-audio/:exerciseId' element={<ProtectedRoute><FindTheCorrectWordAudio /></ProtectedRoute>} />
                            <Route path='/find-the-correct-word-no-audio/:exerciseId' element={<ProtectedRoute><FindTheCorrectWordNoAudio /></ProtectedRoute>} />
                            <Route path='/fast-read/:exerciseId' element={<ProtectedRoute><FastRead /></ProtectedRoute>} />
                            <Route path='/write-derivative-word/:exerciseId' element={<ProtectedRoute><WriteDerivativeWord /></ProtectedRoute>} />
                            <Route path='/pattern-morph/:exerciseId' element={<ProtectedRoute><PatternMorph /></ProtectedRoute>} />
                            <Route path='/word-cracking/:exerciseId' element={<ProtectedRoute><WordCracking /></ProtectedRoute>} />
                            <Route path='/tutorial/:exerciseId' element={<ProtectedRoute><VideoTutorial /></ProtectedRoute>} />
                        </>
                    )}
                </Routes>
            </Router>
        </AppProvider>
    );
}

export default App;